import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../lib/api';
import { SiteContext } from '../../contexts/SiteContext';
import RichTextEditor from '../editor/RichTextEditor';

export default function ContentItemEditorPage({ t }) {
  const { website } = useContext(SiteContext);
  const websiteId = website?._id;
  const { sectionSlug, itemSlug } = useParams();

  const [section, setSection] = useState(null);
  const [item, setItem] = useState(null);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        if (!websiteId || !sectionSlug) return;

        // 1) resolve section
        const { data: sc } = await api.get(`/site-contents/resolve/${websiteId}/${sectionSlug}`);
        if (!alive) return;
        setSection(sc);

        if (itemSlug) {
          // 2a) resolve item by slug → full item (has content/input)
          const { data } = await api.get(`/content-items/resolve/${sc._id}/${itemSlug}`);
          if (!alive) return;
          setItem({ _id: data.id, ...data });
        } else {
          // 2b) no slug: list returns trimmed rows → fetch full doc by id
          const { data: list } = await api.get(`/content-items/by-content/${sc._id}`);
          if (!alive) return;

          if (Array.isArray(list) && list.length) {
            const first = list[0]; // {_id, name, link, updatedAt}
            const { data: full } = await api.get(`/content-items/${first._id}`); // FULL doc
            if (!alive) return;
            setItem({ _id: full.id, ...full });
          } else {
            // create empty item
            const { data: created } = await api.post('/content-items', {
              contentId: sc._id,
              name: sc.name,
              content: '',
              input: '',
            });
            if (!alive) return;
            setItem({ _id: created.item.id, ...created.item });
          }
        }
      } catch (e) {
        if (!alive) return;
        setErr(e?.response?.data?.msg || t('errors.failedToLoad', { defaultValue: 'Failed to load' }));
      } finally {
        alive && setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [websiteId, sectionSlug, itemSlug, t]);

  if (loading) return <div className="p-6">{t('general.loading')}</div>;
  if (err) return <div className="p-6 text-red-600">{err}</div>;
  if (!section) return <div className="p-6">{t('editor.sectionNotFound', { defaultValue: 'Section not found' })}</div>;
  if (!item) return <div className="p-6">{t('editor.itemNotFound', { defaultValue: 'Item not found' })}</div>;

  console.log({ section, item });

  return (
    <div className="p-4 bg-white border rounded shadow">
      <h1 className="text-xl font-semibold mb-3">{item.name}</h1>
      <RichTextEditor
        item={item}
        initialContent={item?.content ?? item?.input ?? ''}
        siteContentId={section._id}
      />
    </div>
  );
}
